import { InjectionToken } from '@angular/core';

export const ORGANIZATION_PREFIX = new InjectionToken<string>('ORGANIZATION_PREFIX');
